import React, { lazy, useEffect, useState, useContext } from "react";
import { CommonValidateAddress } from "./CommonValidateAddress";
import { EMAIL_REGEX_C360 } from "../../constants/ValidationConstants";
import { FlexRow, SmallText, SLNotification, SLGridLayout, SLRowLayout, CompactCol } from "../../components/core/utility";
import useOutsideClick from "../../customHook/use-outside-click";
import { Input } from "@vds/inputs";
import { Button } from "@vds/buttons";
import { Title } from "@vds/typography";
import styled from "styled-components";
import { css } from "@emotion/react";
import { generate } from "shortid";
import { switchTab } from "./utils";
import { Loader } from "@vds/loaders";
import { C4SContext } from "../../context/c4sContext";
import { saveVin } from "../../services/C4S Decommission - Replacement/validateVin";

const HistoricalAddressRow = css`
  @media screen and (min-width: 910px) {
    width: 40%;
    max-width: 37.25rem;
    min-width: 4.125rem;
  }
`;

export const CustomInput = styled(Input)`
  padding-bottom: 0.5rem;
  height: auto;
  width: 100%;
  max-width: 100%;
  & * {
    max-width: 100%;
  }
  & label {
    & p {
      font-size: 12px;
      font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "400")};
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
    }
  }
  & span {
    & span {
      & span {
        width: ${(props) => (props.boxWidth ? props.boxWidth : "")};
      }
    }
  }
  & input {
    font-size: 12px;
    height: ${(props) => (props.height ? props.height : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      border-top: 1px solid #dfe0e0;
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
  & span {
    width: ${(props) => (props.width ? props.width : "")};
    & span {
      & span {
        & div:not(:first-child) {
          & svg {
            display: none; // hide success tick icon
          }
        }
      }
    }
  }
`;
export default function AddAssetAssignment(props) {
  const { cspDetails, workTicketInfo } = useContext(C4SContext);
  const [productInfo] = useState(props.productInfo); // Assuming productInfo is passed as a prop
  const [pendingAssignment, setPendingAssignment] = useState(10);
  const [isLoading, setLoader] = useState(false);
  const [notification, setNotification] = useState(null);
  const [featureValues, setFeatureValues] = useState("");
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [vehicleSubscriptions, setVehicleSubscriptions] = useState([]);
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const [name, setName] = useState({
    value: "",
    error: false,
    errorText: "Enter name",
    success: false,
  });
  const [phone, setPhone] = useState({
    value: "",
    error: false,
    errorText: "Enter phone",
    success: false,
  });
  const [email, setEmail] = useState({
    value: "",
    error: false,
    errorText: "Enter email",
    success: false,
  });
  const [quantity, setQuantity] = useState({
    value: "",
    error: false,
    errorText: "Enter quantity",
    success: false,
  });
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 0) return "";
    if (digits.length > 10) return digits;
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handleFields = (field, value, isAutoPopulated = false) => {
    switch (field) {
      case "Name": {
        if (value && value.length) {
          setName({ value, error: false, errorText: "Enter name", success: true });
        } else {
          setName({ value: "", error: true, errorText: "Enter name", success: false });
        }
        break;
      }
      case "Phone": {
        if (isAutoPopulated) {
          if (value && value.length) {
            setPhone({ value, error: false, errorText: "Enter phone number", success: true });
          } else {
            setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
          }
        } else {
          const isIntlFormat = value.startsWith("+");
          if (isIntlFormat) {
            const rawDigits = value.replace(/[^0-9]/g, "");
            if (rawDigits.length === 0) {
              setPhone({ value: "+", error: true, errorText: "Enter +1 followed by 10 digits", success: false });
            } else {
              const forced = "1" + rawDigits.replace(/^1/, "");
              const cleaned = "+" + forced;
              const phoneDigits = forced.slice(1);
              if (phoneDigits.length === 10) {
                setPhone({ value: cleaned, error: false, errorText: "Enter phone number", success: true });
              } else if (phoneDigits.length > 10) {
                setPhone({ value: cleaned, error: true, errorText: "Only 10 digits allowed", success: false });
              } else {
                setPhone({ value: cleaned, error: true, errorText: "Enter +1 followed by 10 digits", success: false });
              }
            }
          } else {
            const digits = value.replace(/\D/g, "");
            const formatted = formatPhoneNumber(value);
            if (digits.length === 10) {
              setPhone({ value: formatted, error: false, errorText: "Enter phone number", success: true });
            } else if (digits.length > 10) {
              setPhone({ value: formatted, error: true, errorText: "Only 10 digits allowed", success: false });
            } else if (digits.length > 0) {
              setPhone({ value: formatted, error: true, errorText: "Enter 10 digit phone number", success: false });
            } else {
              setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
            }
          }
        }
        break;
      }
      case "Email": {
        if (value && value.length) {
          if (EMAIL_REGEX_C360.test(value)) {
            setEmail({ value, error: false, errorText: "Enter email", success: true });
          } else {
            setEmail({ value, error: true, errorText: "Enter a valid email", success: false });
          }
        } else {
          setEmail({ value: "", error: true, errorText: "Enter email", success: false });
        }
        break;
      }
      case "Quantity": {
        let numVal = parseInt(value);
        if (numVal > 0 && numVal <= pendingAssignment) {
          setQuantity({ value, error: false, errorText: "Enter quantity", success: true });
        } else {
          setQuantity({ value: "", error: true, errorText: `Enter quantity less than or equal to ${pendingAssignment}`, success: false });
        }
        break;
      }
    }
  };
  const handleClickOutside = () => {
    setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);
  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };
  const getVehicleSubscriptions = () => {
    const vehicleSubscriptions = [];
    Object.keys(productInfo).forEach((item) => {
      if (productInfo[item].featureType === "CORE") {
        vehicleSubscriptions.push({
          subscription: productInfo[item].SAPProductID,
          techRefId: productInfo[item].TechRefId,
          vehicleFeatures: [],
        });
      }
    });
    setVehicleSubscriptions(vehicleSubscriptions);
  };
  useEffect(() => {
    if (cspDetails.cspDetails.cspData?.data?.data?.CSP.length > 0) {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CSP[0].CSPContactName);
      handleFields("Email", cspContactDetails.CSP[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CSP[0].CSPContactPhone, true);
    } else {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CASEDetails[0].CSPContactName);
      handleFields("Email", cspContactDetails.CASEDetails[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CASEDetails[0].CSPContactPhone, true);
    }
    const data = productInfo
      .map((item) => item.Feature)
      .reduce((prev, curr) => {
        if (curr?.length > 0) {
          return [prev, ", ", curr];
        } else {
          return [prev, "", curr];
        }
      });
    setFeatureValues(data);
    setPendingAssignment(props.availableQty);
    getVehicleSubscriptions();
    document.getElementById("RightSectionContainer")?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    if (address.verified && name.success && phone.success && email.success && quantity.success) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [address.verified, name.success, phone.success, email.success, quantity.success]);
  const handleCancelClick = () => {
    switchTab(1);
  };
  const handleSaveClick = async () => {
    setLoader(true);
    let payload = {
      vinList: [
        {
          vin: null,
          year: null,
          make: null,
          model: null,
          fuelType: null,
          killSwitch: null,
          emergency: null,
          whhelChair: null,
          weightClass: null,
          quantity: quantity.value,
        },
      ],
      registrationNumber: "",
      accountId: cspDetails.cspDetails.accountId,
      type: "ASSET",
      vehicleAssetName: "",
      address1: address.address1.value,
      address2: address.address2.value,
      city: address.city.value,
      country: address.country.value.description,
      countryCode: address.country.value.code,
      stateCode: address.state.value.erpStateCode,
      zipCode: address.zip.value,
      timezone: address.timezone,
      addressByPass: address.addressByPass,
      locationFound: address.locationFound,
      locusLocationId: address.locusLocationId,
      dpv: address.dpv,
      locusSuggestedAddress: address.locusSuggestedAddress,
      latitude: address.latitude,
      longitude: address.longitude,
      customerName: name.value,
      customerEmail: email.value,
      customerPhone: phone.value,
      createdBy: `${cspDetails.cspDetails.firstName} ${cspDetails.cspDetails.lastName}`,
      sourceApplication: "C360",
      crmRefId: workTicketInfo.workTicketInfo.crmRefId,
      salesOrgId: cspDetails.cspDetails.cspData.data.data.CSP[0].Opp_Sales_Org,
      bundleId: productInfo[0].BundleId,
      bundleOrderType: productInfo[0].OrderDetailType,
      productPlatform: cspDetails.cspDetails.cspData.data.data.ProductPlatform,
      accountBrand: cspDetails.cspDetails.cspData.data.data.Account_Brand,
      vehicleSubscriptions: vehicleSubscriptions,
    };
    let response = await saveVin(payload);
    if (response && response.status === 200) {
      switchTab(1);
    } else {
      notify("Error saving Asset", "error");
    }
    setLoader(false);
  };

  return (
    <div>
      {notification}
      <Loader active={isLoading} fullscreen />
      <Title level={3} style={{ marginTop: "0px" }}>
        {productInfo[0]?.BundleName}
      </Title>
      <SmallText>{featureValues}</SmallText>
      <SmallText>{pendingAssignment} Vehicles Pending Assignment</SmallText>
      <div css={HistoricalAddressRow}>
        <CommonValidateAddress address={address} setAddress={setAddress} showHistoricalAddressDropdown={true} setLoader={setLoader} variant="vehicle" showTitle={true} showTypedAddressOption={false} defaultCountryOnNew="USA" trackLocusFields={true} styles={{ radioGroupWidth: "100%" }} />
        <SLGridLayout>
          <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Contact Name*"
                aria-label="Contact Name"
                error={name.error}
                errorText={name.errorText}
                success={name.success}
                value={name.value}
                maxLength={50}
                css={{ paddingRight: "10px" }}
                onChange={(event) => handleFields("Name", event.target.value, "")}
              />
            </CompactCol>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Phone*"
                aria-label="Phone"
                maxLength={16}
                error={phone.error}
                errorText={phone.errorText}
                success={phone.success}
                value={phone.value}
                onChange={(event) => handleFields("Phone", event.target.value)}
              />
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Email*"
                aria-label="Email"
                error={email.error}
                errorText={email.errorText}
                success={email.success}
                value={email.value}
                onChange={(event) => handleFields("Email", event.target.value, "")}
              />
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Quantity*"
                aria-label="Quantity"
                error={quantity.error}
                errorText={quantity.errorText}
                success={quantity.success}
                value={quantity.value}
                onChange={(event) => handleFields("Quantity", event.target.value, "")}
              />
            </CompactCol>
          </SLRowLayout>
        </SLGridLayout>
      </div>
      <FlexRow style={{ marginTop: "2rem" }}>
        <Button style={{ backgroundColor: "#fff", color: "#000" }} role="button" size="small" aria-label="cancelButton" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button
          style={{ marginLeft: "1rem" }}
          role="button"
          size="small"
          aria-label="saveButton"
          disabled={saveDisabled}
          ariaDisabled={saveDisabled}
          onClick={handleSaveClick}
        >
          Save
        </Button>
      </FlexRow>
    </div>
  );
}

export const AddAssetAssignmentMetadata = {
  name: "Add Asset Assignment",
  id: "Add_Asset_Assignment",
  component: lazy(() => import("./AddAssetAssignment")),
  route: "/connect360/add-asset-assignment",
};
